import React from 'react';
import styles from './PatientProfileDataCompareTableActions.module.scss';

interface ActionButton {
	title: string;
	onClick: () => void;
	allowed: boolean;
}

interface Props {
	children: React.ReactNode | React.ReactNode[];
}

const PatientProfileDataCompareTableActions = ({ children }: Props) => {
	return <div className={styles.actions}>{children}</div>;
};

export default PatientProfileDataCompareTableActions;
